
export const UtilsDate = () => {

    /**
     * 
     * @param {Date} date 
     */
    const formatDDMMMYYYY = ( date) => {


        const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
        let current_datetime = date;
        let formatted_date = current_datetime.getDate() + " de " + months[current_datetime.getMonth()] + ", " + current_datetime.getFullYear()

        return (
            formatted_date
        )

    }

    const formatDDMMMYYYY1 = ( date) => {


        const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
        let current_datetime = date;
        let formatted_date = current_datetime.getDate() + "/" + months[current_datetime.getMonth()] + "/" + current_datetime.getFullYear()

        return (
            formatted_date
        )

    }


    const formatDDMM = (date) => {

        const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
        let current_datetime = date;
        let formatted_date = current_datetime.getDate() + "/" + months[current_datetime.getMonth()] 

        return (
            formatted_date
        )
    }


    const formatDDMMMYYYYHHmm = ( date) => {
        const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
        
        let formatted_date = date.getDate() + "/" + months[date.getMonth()] 
                                                        + "/" + date.getFullYear()
                                                        + " " + date.getHours()
                                                        + ":" + date.getMinutes()

        return (
            formatted_date
        )

    }


    const formatYYYYMMdd = ( date) => {


        let mes =  (date.getMonth() +1) < 10 ? "0"+(date.getMonth() +1) : (date.getMonth() +1)
        let dia =  date.getDate() <10 ? "0"+date.getDate() : date.getDate() 
        let formatted_date = date.getFullYear() + "-" + mes + "-" + dia
                                                       
        return (
            formatted_date
        )

    }

    return {
        formatDDMMMYYYY,
        formatDDMM,
        formatDDMMMYYYYHHmm,
        formatYYYYMMdd,
        formatDDMMMYYYY1
    };

}